document.addEventListener('click', function(e) {
  const toggle = e.target.closest('[data-quick-toggle]');
  if (toggle) {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
    return;
  }

  const checkoutButton = e.target.closest('[data-quick-checkout]');
  if (checkoutButton) {
    const form = checkoutButton.closest('form');
    if (!form) return;
    quickCheckout(form, checkoutButton);
  }
});

document.addEventListener('submit', async function(e) {
  const form = e.target.closest('.quick-purchase-form');
  if (!form) return;

  /* Let Shopify's accelerated/dynamic checkout submit itself. */
  if (e.submitter && !e.submitter.matches('[data-quick-add]')) return;

  e.preventDefault();
  const button = form.querySelector('[data-quick-add]');
  if (!button) return;
  const originalText = button.textContent;
  button.classList.add('is-loading');
  button.textContent = 'ADDING…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Accept': 'application/json'},
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add item');
    button.classList.remove('is-loading');
    button.classList.add('is-added');
    button.textContent = 'ADDED ✓';
    document.dispatchEvent(new CustomEvent('closether:cart-updated'));
    setTimeout(function(){
      button.classList.remove('is-added');
      button.textContent = originalText;
    }, 1600);
  } catch (err) {
    button.classList.remove('is-loading');
    button.textContent = 'TRY AGAIN';
    setTimeout(function(){ button.textContent = originalText; }, 1800);
  }
});

async function quickCheckout(form, button) {
  const originalText = button.textContent;
  button.disabled = true;
  button.classList.add('is-loading');
  button.textContent = 'LOADING…';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Accept': 'application/json'},
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add item');
    window.location.assign('/checkout');
  } catch (err) {
    button.disabled = false;
    button.classList.remove('is-loading');
    button.textContent = 'TRY AGAIN';
    setTimeout(function(){ button.textContent = originalText; }, 1800);
  }
}
